import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';

export class Area {
  public institutionId?: Number[];
  public name?: String;
  public id?: Number;
}
export class Responsable {
  public areaId?: Number[];
  public name?: String;
  public first_surname?: String;
  public second_surname?: String;
  public email?: String;
  public position?: String;
  public id?: Number;
  public isValidator?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ResponsableService {
  private apiURL = environment.apiURL_institucion;
  private headers = new HttpHeaders().append('Content-Type', 'application/json')
    .append('Authorization', 'Bearer ' + localStorage.getItem('token'));

  constructor(
    private http: HttpClient,
    private cookies: CookieService,
  ) { }
  /** Responsables */
  public getResponsable(): Observable<any> {
    const apiURL = `${this.apiURL}area`;
    return this.http.get(`${apiURL}`, { headers: this.headers });
  }
  public postResponsable(res: any): Observable<any> {
    const responsable: Responsable = {
      areaId: res.areaId,
      name: res.name,
      first_surname: res.first_surname,
      second_surname: res.second_surname,
      email: res.email,
      position: res.position,
    }
    const body = JSON.stringify(responsable);
    const apiURL = this.apiURL + "responsable";
    return this.http.post(`${apiURL}`, body, { headers: this.headers });
  }
  public patchResponsableValidador(res: any): Observable<any> {
    const responsable: Responsable = {
      isValidator: res.isValidator,
    }
    const body = JSON.stringify(responsable);
    const apiURL = this.apiURL + "responsable/" + res.id;
    return this.http.patch(`${apiURL}`, body, { headers: this.headers });
  }
  public patchResponsable(res: any): Observable<any> {
    const responsable: Responsable = {
      areaId: res.areaId,
      name: res.name,
      first_surname: res.first_surname,
      second_surname: res.second_surname,
      email: res.email,
      position: res.position,
    }
    const body = JSON.stringify(responsable);
    const apiURL = this.apiURL + "responsable/" + res.id;
    return this.http.patch(`${apiURL}`, body, { headers: this.headers });
  }
  public deleteResponsable(res: any): Observable<any> {
    const apiURL = this.apiURL + "responsable/" + res.id;
    return this.http.delete(`${apiURL}`, { headers: this.headers });
  }
  /** Area */
  public postArea(area: any): Observable<any> {
      const ar: Area = {
        institutionId: area.institutionId,
        name: area.name
      }
      const body = JSON.stringify(ar);
      const apiURL = this.apiURL + "area";
      return this.http.post(`${apiURL}`, body, { headers: this.headers });
    }
  public patchArea(area: any): Observable<any> {
    const ar: Area = {
      institutionId: area.institutionId,
      name: area.name
    }
    const body = JSON.stringify(ar);
    const apiURL = this.apiURL + "area/" + area.id;
    return this.http.patch(`${apiURL}`, body, { headers: this.headers });
  }
  public deleteArea(area: any): Observable<any> {
    const apiURL = this.apiURL + "area/" + area.id;
    return this.http.delete(`${apiURL}`, { headers: this.headers });
  }
}
